export default "__VITE_ASSET__CKZijXdf__"